export const toTwoDecimaNumbers = (value) => {
  return value.toFixed(2);
}